import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";

export class StoreMaterialPageReq extends PaginationReq {
  materialName: string = ""; //材料名称
  repertotyId: string = ""; // 仓库Id
  supplierId: string = "";
  size:number=20
  constructor(id, companyId) {
    super();
    this.repertotyId = id;
    this.supplierId = companyId;
  }
}

export class StoreMaterialListRecord extends UpdaterResp {
  storageId: string = ""; //库存id
  bizId: string = ""; // 库存来源业务ID
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialModel: string = ""; // 规格型号
  materialBrand: string = ""; // 品牌
  materialUnit: string = ""; // 结算单位
  repertotyName: string = ""; // 仓库
  repertotyId: string = ""; // 仓库
  count: number = 0; // 库存数量
  storageQuality: string = ""; // 库存质量
  storageQualityName: string = ""; // 库存质量
  batchBizNo: string = ""; // 批次编号
  batchId: string = ""; // 批次ID
  supplierName: string = ""; // 供应商名称
  taxPrice: number = 0; // 含税单价-采购单价/含税-采购成本
  putDate: string = ""; // 入库日期
  purchaseOrderId: string = ""; // 关联采购订单ID
  purchaseOrderNo: string = ""; // 关联采购订单ID
  projectId: string = ""; // 项目
  projectName: string = ""; // 项目
  systemName: string ="";//系统名称
}

export class StoreMaterialPageResp extends PaginationResp<StoreMaterialListRecord> {}
